// VendorcatalogApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_STORE_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    localStorage.removeItem('authtoken');
  }

  return result;
};

export const VendorcatalogApi = createApi({
  reducerPath: 'VendorcatalogApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Product', 'Category'], // Define tag types
  endpoints: (builder) => ({
    // ✅ Vendor Product List
    getVendorProductList: builder.query({
      query: (params) => ({
        url: `/catalog/vendor/products/`,
        params: params,
      }),
      providesTags: ['Product'], // This will cache until invalidated
    }),

    // ✅ Get All Categories
    getCategories: builder.query({
      query: () => ({
        url: `/catalog/get-categories/`,
      }),
      providesTags: ['Category'], // This will cache until invalidated
    }),

    // ✅ Create Product
    createProduct: builder.mutation({
      query: (payload) => ({
        url: `/catalog/products-create/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Product'], // This will invalidate product cache
    }),

    // ✅ Get Product Details by ID
    getProductById: builder.query({
      query: (id) => ({
        url: `/catalog/products/${id}/`,
      }),
      providesTags: (result, error, id) => [{ type: 'Product', id }], // Cache by product ID
    }),

    // ✅ Update Product
    updateProduct: builder.mutation({
      query: (formData) => ({
        url: `/catalog/products/${formData.get('id')}/update/`,
        method: 'PATCH',
        body: formData,
      }),
      invalidatesTags: ['Product'], // This will invalidate all product caches
    }),

  }),
});

// ✅ Export all hooks
export const {
  useGetVendorProductListQuery,
  useGetCategoriesQuery,
  useCreateProductMutation,
  useGetProductByIdQuery,
  useUpdateProductMutation,
} = VendorcatalogApi;